import React from "react";
import { cn } from "./utils";
import { border } from "./tokens";

const paddingMap = {
  none: "",
  sm:   "px-5 py-4",
  md:   "p-5",
  lg:   "p-6",
};

const roundedMap = {
  none: "",
  sm:   "rounded-xl",
  lg:   "rounded-2xl",
};

export function Panel({
  children,
  className,
  padding = "md",
  rounded = "none",
  shadow = false,
  style,
  ...props
}) {
  return (
    <div
      className={cn(
        "bg-white",
        paddingMap[padding],
        roundedMap[rounded],
        shadow && "shadow-sm",
        className
      )}
      style={{ border: border.card, ...style }}
      {...props}
    >
      {children}
    </div>
  );
}
